import { TableColumnMeta } from "ds/components/Table/types";

import { IdpGroupFilterItemKeys } from "../constants";

export enum IDP_GROUP_COLUMN_ID {
  GROUP_ID = "GROUP_ID",
  DESCRIPTION = "DESCRIPTION",
  USERS = "USERS",
  LAST_LOGIN = "LAST_LOGIN",
  LOGIN_METHOD = "LOGIN_METHOD",
  STATUS = "STATUS",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 2000;

export const IDP_GROUP_COLUMNS_STORAGE_KEY = "idpGroupColumnsConfigV2";

export const SORT_CONFIG: Partial<Record<IDP_GROUP_COLUMN_ID, IdpGroupFilterItemKeys>> = {
  [IDP_GROUP_COLUMN_ID.GROUP_ID]: IdpGroupFilterItemKeys.GroupId,
  [IDP_GROUP_COLUMN_ID.USERS]: IdpGroupFilterItemKeys.Users,
  [IDP_GROUP_COLUMN_ID.LOGIN_METHOD]: IdpGroupFilterItemKeys.IdentityProvider,
  [IDP_GROUP_COLUMN_ID.LAST_LOGIN]: IdpGroupFilterItemKeys.LastLogin,
  [IDP_GROUP_COLUMN_ID.STATUS]: IdpGroupFilterItemKeys.Status,
};

export const IDP_GROUP_COLUMN_CONFIG: Record<IDP_GROUP_COLUMN_ID, TableColumnMeta> = {
  [IDP_GROUP_COLUMN_ID.GROUP_ID]: {
    id: IDP_GROUP_COLUMN_ID.GROUP_ID,
    title: "Group ID",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    allowsSorting: true,
    canPin: true,
    canMove: true,
  },
  [IDP_GROUP_COLUMN_ID.DESCRIPTION]: {
    id: IDP_GROUP_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 200,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    allowsSorting: false,
    canPin: true,
    canMove: true,
  },
  [IDP_GROUP_COLUMN_ID.USERS]: {
    id: IDP_GROUP_COLUMN_ID.USERS,
    title: "Users",
    minWidth: 150,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    allowsSorting: true,
    canPin: true,
    canMove: true,
  },
  [IDP_GROUP_COLUMN_ID.LOGIN_METHOD]: {
    id: IDP_GROUP_COLUMN_ID.LOGIN_METHOD,
    title: "Method",
    minWidth: 150,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    allowsSorting: true,
    canPin: true,
    canMove: true,
  },
  [IDP_GROUP_COLUMN_ID.LAST_LOGIN]: {
    id: IDP_GROUP_COLUMN_ID.LAST_LOGIN,
    title: "Last login",
    minWidth: 150,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    allowsSorting: true,
    canPin: true,
    canMove: true,
  },
  [IDP_GROUP_COLUMN_ID.STATUS]: {
    id: IDP_GROUP_COLUMN_ID.STATUS,
    title: "Status",
    minWidth: 150,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    allowsSorting: true,
    canPin: true,
    canMove: true,
  },
  [IDP_GROUP_COLUMN_ID.DROPDOWN]: {
    id: IDP_GROUP_COLUMN_ID.DROPDOWN,
    title: "Group actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    canHide: false,
    resizable: false,
    configurable: false,
    allowsSorting: false,
    canPin: false,
    canMove: false,
  },
};
